module.exports = __webpack_public_path__ + "img/middlePage.376e4927.jpg";